import React from "react";
import { createRoot } from "react-dom/client";
//import './index.css';
//import 'bootstrap/dist/css/bootstrap.min.css'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

import "./assets/styles/bootstrap.custom.css";
import "./assets/styles/index.css";

import LoginScreen from "./screens/LoginScreen";
import CustomerDetailsScreen from "./screens/CustomerDetailsScreen";
import GymPaymentHistoryScreen from "./screens/GymPaymentHistoryScreen";
import PendingPaymentsScreen from "./screens/PendingPaymentsScreen";
import PrivateRoute from "./components/PrivateRoute";
import GymsScreen from "./screens/GymsScreen";
import WhatsAppAdsScreen from "./screens/WhatsAppAdsScreen";
import GymDetails from "./screens/GymDetails";
import TodaysCustomerScreen from "./screens/TodaysCustomerScreen";
import WsMessagesScreen from "./screens/WsMessagesScreen";
import ExpiredGymDetails from "./screens/ExpiredGymDetails";
import FreeGymDetails from "./screens/FreeGymDetails";
import RenewGymSubscriptionScreen from "./screens/RenewGymSubscriptionScreen";
import UpdatePaymentsScreen from "./screens/updatePaymentScreen";
import WhatsAppAdsToCustomers from "./screens/WhatsAppAdsToCustomers";
import AdminLogs from "./screens/AdminLogsScreen";
import AllGymDetails from "./screens/AllGymDetails";
import RegisterScreen from "./screens/RegisterScreen";
import ResetPasswordScreen from "./screens/ResetPasswordScreen";
import GymProfileScreen from "./screens/GymProfileScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/register/:gymId" element={<RegisterScreen />} />
      <Route path="" element={<PrivateRoute />}>
        <Route path="/" element={<AllGymDetails />}></Route>
        <Route path="/availableGyms" element={<GymsScreen />}></Route>
        <Route path="/whatsAppAds" element={<WhatsAppAdsScreen />}></Route>
        <Route path="/allGyms" element={<AllGymDetails />}></Route>
        <Route path="/gymDetails" element={<GymDetails />}></Route>
        <Route path="/resetPassword" element={<ResetPasswordScreen />} />
        <Route
          path="/expiredGymDetails"
          element={<ExpiredGymDetails />}
        ></Route>
        <Route path="/freeGyms" element={<FreeGymDetails />}></Route>
        <Route path="/getAllMessages" element={<WsMessagesScreen />}></Route>
        <Route
          path="/customerDetails"
          element={<CustomerDetailsScreen />}
        ></Route>
        <Route
          path="/whatsAppAdsToCustomers"
          element={<WhatsAppAdsToCustomers />}
        ></Route>
        <Route
          path="/todaysCustomers"
          element={<TodaysCustomerScreen />}
        ></Route>
        <Route
          path="/pendingPayments"
          element={<PendingPaymentsScreen />}
        ></Route>
        <Route
          path="/paymentHistory"
          element={<GymPaymentHistoryScreen />}
        ></Route>
        <Route
          path="/renewSubscription"
          element={<RenewGymSubscriptionScreen />}
        ></Route>
        <Route path="/adminLogs" element={<AdminLogs />}></Route>
        <Route path="/payNow" element={<UpdatePaymentsScreen />}></Route>
        <Route path="/gymProfile/:gymId" element={<GymProfileScreen />}></Route>
      </Route>
    </Route>
  )
);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
